import React from 'react';

import Layout from '../../components/Layout';
import CallInfoSidebar from './call-info-sidebar';
import CallSubmissionFormContainer from './call-submission-form';

const SubmitPhoneCall = () => {
  return (
    <Layout sidebar={<CallInfoSidebar />}>
      <CallSubmissionFormContainer />
    </Layout>
  );
};

export default SubmitPhoneCall;
